import { getAuthCookie } from "@/src/utils/authCookie";

export const API_BASE = process.env.NEXT_PUBLIC_API_URL!;
export const MOBILE_API = process.env.NEXT_PUBLIC_MOBILE_API_URL!;
export const OTP_API = process.env.NEXT_PUBLIC_OTP_API_URL!;
export const API_V2 = process.env.NEXT_PUBLIC_API_V2_URL!;

interface FetchOptions {
  method?: string;
  body?: unknown;
  token?: string;
}

export async function apiFetch<T = unknown>(
  url: string,
  opts: FetchOptions = {}
): Promise<T> {
  const { method = "GET", body, token } = opts;
  const tokenFromCookie = getAuthCookie();
  const finalToken = token || tokenFromCookie || undefined;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (finalToken) {
    headers["Authorization"] = `Bearer ${finalToken}`;
  }

  const res = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({ message: res.statusText }));
    const message =
      error.message ||
      error.response?.message ||
      error.error ||
      `Request failed: ${res.status}`;
    throw new Error(message);
  }

  return res.json();
}
